import { InputComponentProps, ValidatingInput } from '~/components/validating-input';

const KWH_LOWER_LIMIT = 3;

export const EstimatedDailyKwh = ({ ...props }: InputComponentProps) => {
  const validate = ({ value }) => {
    if (Number(value) > KWH_LOWER_LIMIT) return true;
    return 'Please enter a valid average daily electric use in kWh';
  };

  return (
    <ValidatingInput
      label="Average daily electric use in kWh"
      name="estimatedDailyKwh"
      validate={validate}
      type="number"
      {...props}
      helpContent={{
        type: 'ENROLLMENT_FIELDS',
      }}
    />
  );
};
